import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../../assets/images/Dashboard/chevron-down.svg';
import action from '../../../assets/images/Dashboard/action-img.svg';
import edit from '../../../assets/images/Dashboard/edit-img.svg';
import view from '../../../assets/images/Dashboard/view-img.svg';
import ascToDesc from '../../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../../assets/images/CustomerManagement/descToAsc.svg';
import SbActionDropdownButton from '../../Buttons/SbActionDropdownButton';
import SbStatusDropdown from '../../Buttons/SbStatusDropdown';
import { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import calendar from '../../../assets/images/Dashboard/calendar-icon.svg';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

import searchIcon from '../../../assets/images/Dashboard/search-icon.svg'

import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import AddMaterialMasterExtended from './AddMaterialMasterExtended';
import MaterialMasterExtendedBulkUploadModal from './MaterialMasterExtendedBulkUploadModal';

const data = [
    {
        materialNumber: 1001,
        mrpGroup: '--',
        mrpType: '--',
        lotSizeProcedure: '--',
        reOrderPoint: '--',
        maxStockLevel: '--',
        abcIndicator: '--',
        replenishmentLeadTime: '--',
        safetyStock: '--',
        mrpArea: '--',
        procurementType: '--',
        specialProcurement: '--',
        productionStorageLocation: '--',
        slocForExernalProcurement: '--',
        grProcessingTime: '--',
        plantDeliveryTime: '--',
        scheduleMarginKey: '--',
        serviceLevel: '--',
        availabilityCheck: '--',
        criticalityCode: '--',
        fsnType: '--',
        sdeAnalysis: '--',
        capitalSpares: '--',
        fixedLotSize: '--',
        extendedDateOfMaterials: '--',
    },
];

const columns = [
    { id: 'materialNumber', label: 'MATERIAL NUMBER', align: 'left', minWidth: '170px' },
    { id: 'mrpGroup', label: 'MRP GROUP', align: 'left', minWidth: '130px' },
    { id: 'mrpType', label: 'MRP TYPE', align: 'left', minWidth: '120px' },
    { id: 'lotSizeProcedure', label: 'LOT SIZE PROCEDURE', align: 'left', minWidth: '180px' },
    { id: 'reOrderPoint', label: 'REORDER POINT', align: 'left', minWidth: '150px' },
    { id: 'maxStockLevel', label: 'MAX STOCK LEVEL', align: 'left', minWidth: '170px' },
    { id: 'abcIndicator', label: 'ABC INDICATOR', align: 'left', minWidth: '150px' },
    { id: 'replenishmentLeadTime', label: 'REPLENISHMENT LEAD TIME', align: 'left', minWidth: '220px' },
    { id: 'safetyStock', label: 'SAFETY STOCK', align: 'left', minWidth: '150px' },
    { id: 'mrpArea', label: 'MRP AREA', align: 'left', minWidth: '120px' },
    { id: 'procurementType', label: 'PROCUREMENT TYPE', align: 'left', minWidth: '180px' },
    { id: 'specialProcurement', label: 'SPECIAL PROCUREMENT', align: 'left', minWidth: '200px' },
    { id: 'productionStorageLocation', label: 'PRODUCTION STORAGE LOCATION', align: 'left', minWidth: '280px' },
    { id: 'slocForExernalProcurement', label: 'SLOC FOR EXTERNAL PROCUREMENT', align: 'left', minWidth: '280px' },
    { id: 'grProcessingTime', label: 'GR PROCESSING TIME', align: 'left', minWidth: '200px' },
    { id: 'plantDeliveryTime', label: 'PLANT DELIVERY TIME', align: 'left', minWidth: '190px' },
    { id: 'scheduleMarginKey', label: 'SCHEDULE MARGIN KEY', align: 'left', minWidth: '200px' },
    { id: 'serviceLevel', label: 'SERVICE LEVEL (%)', align: 'left', minWidth: '180px' },
    { id: 'availabilityCheck', label: 'AVAILABILITY CHECK', align: 'left', minWidth: '200px' },
    { id: 'criticalityCode', label: 'CRITICALITY CODE', align: 'left', minWidth: '180px' },
    { id: 'fsnType', label: 'FSN TYPE', align: 'left', minWidth: '120px' },
    { id: 'sdeAnalysis', label: 'SDE ANALYSIS', align: 'left', minWidth: '150px' },
    { id: 'capitalSpares', label: 'CAPITAL SPARES', align: 'left', minWidth: '160px' },
    { id: 'fixedLotSize', label: 'FIXED LOT SIZE', align: 'left', minWidth: '150px' },
    { id: 'extendedDateOfMaterials', label: 'EXTENDED DATE OF MATERIALS', align: 'left', minWidth: '250px' },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const MaterialRequirementPlanningTable = (props) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleMenuItemClick = (action) => {
        if (action === 'edit') {
            console.log('Edit Details for:', selectedCustomer);
            // Implement edit functionality here
        } else if (action === 'view') {
            console.log('View Details for:', selectedCustomer);
            // Implement view functionality here
        }
        handleActionClose();
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = data.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [data, order, orderBy]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    return (
        <>
            <Row className='customermanagement-btns-container'>
                <Col md={3} className='customermanagement-backbtn-div'>
                    <span>Material Master Extended</span>
                </Col>
                <Col md={9} className='customermanagement-search-filter'>
                    <div className='customermanagement-header-btns filter-btn'>
                        <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                        {showFilterMenu && (
                            <Dropdown.Menu show className='filter-dropdown-options'>
                                <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                    <img src={columnFilter} alt="Column Filter" />&nbsp;&nbsp;
                                    Column Filter
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                    <img src={valueFilter} alt="Value Filter" />&nbsp;&nbsp;
                                    Value Filter
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        )}
                    </div>
                    <Col md={5}>
                        <div className='customermanagement-search'>
                            <Form.Control type="search" placeholder='Search' />
                            <img src={searchIcon} alt="Search" />
                        </div>
                    </Col>
                    <SbDropdownButton
                        // pageName="Zone Master"
                        btnName="Add"
                        openAddModal={() => { handleOpenModal("") }}
                        addBulkModel={handleOpenBulkUploadModal}
                    />
                </Col>
            </Row>
            <div className='customermanagement-table-div'>
                <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }} className='table-header-div'>
                                            {column.label}
                                            {column.sortable !== false && (
                                                <IconButton
                                                    size="small"
                                                    onClick={(event) => handleRequestSort(event, column.id)}
                                                >
                                                    <img src={SortIcon} alt="Sort" />
                                                </IconButton>
                                            )}
                                        </div>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sortedData.map((customer) => (
                                <TableRow key={customer.id}>
                                    {columns.map((column) => (
                                        <TableCell key={column.id} align={column.align}>
                                            {column.id === 'action' ? (
                                                <SbActionDropdownButton openAddModal={handleOpenModal} />
                                            ) : (
                                                customer[column.id]
                                            )}
                                        </TableCell>

                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                    >
                        <MenuItem onClick={() => handleSortOrderChange('asc')}>
                            <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                            Ascending to Descending
                        </MenuItem>
                        <MenuItem onClick={() => handleSortOrderChange('desc')}>
                            <img src={descToAsc} alt="" />&nbsp;&nbsp;
                            Descending to Ascending
                        </MenuItem>
                    </Menu>
                </TableContainer>
                {isModalOpen && <AddMaterialMasterExtended open={isModalOpen} handleClose={handleCloseModal} />}
                {
                    showBulkUploadModal && <MaterialMasterExtendedBulkUploadModal
                        showBulkUploadModal={showBulkUploadModal}
                        handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                    // deptData={deptData}
                    />
                }
            </div>
        </>
    );
};

export default MaterialRequirementPlanningTable;
